exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pre-liner[data-v-4a3994ec]{white-space:pre-line;width:100%;overflow:auto}", ""]);

// exports
